import { useGetActiveDirectoryQuery } from "@/services";
import { Spin } from "antd";
import { useIntl } from "react-intl";

interface IProps {
  activeDirectoryId: string;
}

const InlineActiveDirectory = ({ activeDirectoryId }: IProps) => {
  const intl = useIntl();
  const { data: activeDirectory, isFetching } = useGetActiveDirectoryQuery({
    id: activeDirectoryId,
  });

  if (isFetching) return <Spin size="small" />;

  if (activeDirectory?.length === 0) return null;

  return (
    <span>
      {activeDirectory?.[0].displayName ||
        intl.formatMessage({ id: "general.unknown" })}
    </span>
  );
};

export default InlineActiveDirectory;
